module.exports = __webpack_public_path__ + "static/media/calendar_today-24px.dc3857c3.svg";